module.exports = __webpack_public_path__ + "img/65.86e32ea8.jpg";